// extracted by mini-css-extract-plugin
export var bubble = "_3s-0";
export var container = "_3s-f";
export var contrastBorder = "_3s-g";
export var greyOut = "_3s-2";
export var initialsColor0 = "_3s-3";
export var initialsColor1 = "_3s-4";
export var initialsColor10 = "_3s-d";
export var initialsColor11 = "_3s-e";
export var initialsColor2 = "_3s-5";
export var initialsColor3 = "_3s-6";
export var initialsColor4 = "_3s-7";
export var initialsColor5 = "_3s-8";
export var initialsColor6 = "_3s-9";
export var initialsColor7 = "_3s-a";
export var initialsColor8 = "_3s-b";
export var initialsColor9 = "_3s-c";
export var initialsWrapper = "_3s-1";
export var large = "_3s-l";
export var medium = "_3s-k";
export var mediumSmall = "_3s-j";
export var mediumSmallMedium = "_3s-o";
export var micro = "_3s-h";
export var small = "_3s-i";
export var tiny = "_3s-n";
export var xTiny = "_3s-m";